module.exports = __webpack_public_path__ + "static/media/games.aedc67c6.jpeg";